import { responseHandler } from '../api/api';
import { post, parseData } from './common';
const getErrorViewerLogs = () => post('/Services/LogService.asmx/Get24HourErrors').then(parseData);
const createLogEvent = (Payload) => post('/Services/LogService.asmx/CreateLogEvent', { Payload })
    .then(parseData)
    .then(responseHandler);
export { getErrorViewerLogs, createLogEvent };
